import { PartialRecursive } from '@bridebook/models/source/abstract/_';
import { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';

const result: PartialRecursive<IBucket['settings']> = {
  smartEmails: true,
  searchPresets: true,
  searchFilters: {
    venue: {
      overviewSection: [
        'highestReviewed',
        'exclusiveUse',
        'weddingLicence',
        'hasAccommodation',
        'lateNightExtensionAvailable',
        'alcoholLicense',
      ],
      venueType: [
        'countryHouseManorHouse',
        'barn',
        'castle',
        'hotel',
        'uniqueVenueType',
        'pubRestaurant',
        'conferenceCentre',
      ],
    },
  },
};

export default result;
